<template>
    <ul class="nav footer-links">
        <li data-v-ba7fa12e="" class="nav-item">
            <a href="https://www.animod.de/" target="_blank" rel="noopener" class="nav-link">
                Shop
            </a>
        </li>
        <li class="nav-item">
            <a href="https://www.animod.de/c/impressum" target="_blank" rel="noopener" class="nav-link">
                Impressum
            </a>
        </li>
        <li class="nav-item">
            <a href="https://www.animod.de/c/agb" target="_blank" rel="noopener" class="nav-link">
                AGB
            </a>
        </li>
        <li class="nav-item">
            <a href="https://www.animod.de/c/datenschutz" target="_blank" rel="noopener" class="nav-link">
                Datenschutzerklärung
            </a>
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'FooterLinks',
        components: {},
        data () {
            return {}
        },
        props: {},
        computed: {},
        methods: {}
    }
</script>

<style scoped lang="scss">
    .footer-links {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;

        .nav-link {
            padding: 0.5rem 1rem;
            text-decoration: underline;
            transition: color .5s ease;
            color: hsl(0, 0%, 80%);
            display: block;

            &:visited {
                color: hsl(0, 0%, 70%);
            }
        }
    }
</style>
